import React from 'react';
import externalLinkProps from './externalLinkProps';

/**
 * `.btn` de la maquette. Les variantes correspondent aux modificateurs CSS
 * existants : yellow | teal | white | outline.
 *
 * Rend un `<a>` dès qu'un `href` est fourni — la maquette utilisait des
 * `<button>` inertes pour « En savoir + » sur 5 cartes sur 6 (piège n°4).
 */
const Button = ({ variant, href, withArrow = false, className = '', children, ...rest }) => {
  const classes = ['btn', variant, className].filter(Boolean).join(' ');
  const content = (
    <>
      {children}
      {withArrow && <span className="arr">→</span>}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} {...externalLinkProps(href)} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {content}
    </button>
  );
};

export default Button;
